<template>
  <!-- Main content -->
  <section class="content">
    <!-- Info boxes -->
    <div class="row">
      <v-app>
        <v-content>
          <v-container fluid>
            <v-layout row>
              <v-flex xs12 sm2>
                <!-- <v-autocomplete
                  v-model="selectedStore"
                  :items="storeNames"
                  item-text="name"
                  label="Store"
                  @change="getDataFromApi"
                  class="text-truncate"
                ></v-autocomplete> -->
                <v-autocomplete
                  v-model="selectedStore"
                  :items="storeNames"
                  item-text="name"
                  label="Store"
                  @change="handleStoreChange"
                  class="text-truncate"
                ></v-autocomplete>
              </v-flex>

              <v-spacer> </v-spacer>
              <v-flex xs12 sm2>
                <!-- <v-autocomplete v-model="accountNo" :items="results" label="Account Number" class="text-truncate"
                  outlined dense solo></v-autocomplete> -->
              </v-flex>

              <v-spacer> </v-spacer>
              <v-flex xs12 sm2>
                <!-- <v-autocomplete v-model="fileType" :items="fileTypes" label="File Type" class="text-truncate"
                  outlined dense solo></v-autocomplete> -->
              </v-flex>

              <v-spacer> </v-spacer>
              <v-flex xs12 sm2>
                <v-menu
                  ref="startDtMenu"
                  :close-on-content-click="false"
                  v-model="startDtMenu"
                  :nudge-right="40"
                  :return-value.sync="startDt"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    :value="formattedStartDt"
                    label="Start Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="startDt"
                    @input="
                      () => {
                        $refs.startDtMenu.save(startDt);
                        getDataFromApi();
                      }
                    "
                  >
                  </v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs12 sm2>
                <v-menu
                  ref="endDtMenu"
                  :close-on-content-click="false"
                  v-model="endDtMenu"
                  :nudge-right="40"
                  :return-value.sync="endDt"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    :value="formattedEndDt"
                    label="End Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="endDt"
                    @input="
                      () => {
                        $refs.endDtMenu.save(endDt);
                        getDataFromApi();
                      }
                    "
                  >
                  </v-date-picker>
                </v-menu>
              </v-flex>

              <!-- <v-flex xs12 sm1 mr-3 pt-2>
                <v-btn color="primary" small @click="getStmtData">VIEW</v-btn>
              </v-flex> -->
              <v-flex xs12 sm1 mr-3 pt-2>
                <v-btn color="primary" small @click="exportExcelFile"
                  >DOWNLOAD</v-btn
                >
              </v-flex>
            </v-layout>

            <!-- <v-flex xs12 sm12 lg12> 
              <object v-if="loadstmt" type="application/pdf" :data="pdfData"
                style="width: 100%; height: 500px;"></object>
            </v-flex> -->
            <span class="body-2 font-weight-regular accent--text"
              >POS Transactions
            </span>
            <v-flex xs12 sm12 lg12>
              <v-data-table
                :headers="headers"
                :items="filteredResults"
                :pagination.sync="pagination"
                :total-items="totalResults"
                :loading="loading"
                class="elevation-1"
              >
                <template slot="headerCell" slot-scope="{ header }">
                  <span
                    class="body-2 font-weight-regular accent--text"
                    v-text="header.text"
                  />
                </template>
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.settlementDate }}</td>
                  <td>{{ props.item.posId }}</td>
                  <td>{{ props.item.transactionNarration }}</td>
                  <td>{{ props.item.card }}</td>
                  <td>{{ props.item.approvalCode }}</td>
                  <td>{{ props.item.transactionDate }}</td>
                  <td>
                    {{
                      parseFloat(props.item.amount).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    }}
                  </td>
                  <td>
                    {{
                      parseFloat(props.item.commission).toLocaleString(
                        undefined,
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                      )
                    }}
                  </td>
                  <td>
                    {{
                      parseFloat(props.item.cashback).toLocaleString(
                        undefined,
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                      )
                    }}
                  </td>
                  <td>
                    {{
                      parseFloat(props.item.cashback_COMM).toLocaleString(
                        undefined,
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                      )
                    }}
                  </td>
                  <td>
                    {{
                      parseFloat(props.item.settlementAmount).toLocaleString(
                        undefined,
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                      )
                    }}
                  </td>
                </template>
                <template slot="no-data">
                  <p>
                    Kindly Select Start Date
                    and End Date to download the transactions statement
                  </p>
                  <Loader :visible="loadingSpin" />
                  <v-btn color="primary" @click="getDataFromApi" round
                    >Reload</v-btn
                  >
                </template>
              </v-data-table> 
            </v-flex>
          </v-container>
        </v-content>
      </v-app>
    </div>
    <!-- /.row -->
  </section>
  <!-- /.content -->
</template>
<script>
import axios from "axios";
import config from "../../../config";
import store from "../../../store";
import Loader from "./Loader.vue";

export default {
  name: "viewstatements",
  components: {
    Loader,
  },
  data: function () {
    return {
      headers: [
        { text: "Settlemet Date", value: "settlementDate", sortable: false },
        { text: "Terminal", value: "posId", sortable: false },
        { text: "Location", value: "transactionNarration", sortable: false },
        { text: "Card", value: "card", sortable: false },
        { text: "Approval Code", value: "approvalCode", sortable: false },
        { text: "Transaction Date", value: "transactionDate", sortable: false },
        { text: "Transaction Amount", value: "amount", sortable: false },
        { text: "Bank Commission", value: "commission", sortable: false },
        { text: "Cash Back", value: "cashback", sortable: false },
        {
          text: "Cash Back Commission",
          value: "cashback_COMM",
          sortable: false,
        },
        { text: "Net Paid", value: "settlementAmount", sortable: false },
      ],
      results: [],
      loadingSpin: false,
      message: "",
      error: "",
      loading: false,
      pagination: { page: 1, rowsPerPage: 10 },
      totalResults: 0,
      stores: [],
      merchantId: "",
      loggedInUser: "",
      selectedStore: "ALL",
      storeIds: [],
      storeNames: [],
      startDateMenu: false,
      endDateMenu: false,
      startDate: new Date().toISOString().split("T")[0],
      endDate: new Date().toISOString().split("T")[0],
      supportedExportTypes: ["EXCEL", "PDF"],
      exportType: "EXCEL",
      exportStartDateMenu: false,
      exportEndDateMenu: false,
      exportStartDate: null,
      exportEndDate: null,
      dialog: false,
      merchantid: 0,
      startDt: null,
      accountNo: "",
      fileType: "",
      endDt: null,
      loadstmt: false,
      pdfData: "",
      startDtMenu: false,
      endDtMenu: false,
      exportstartDtMenu: false,
      exportendDtMenu: false,
      exportstartDt: this.startDt,
      exportendDt: this.endDt,
      fileTypes: ["PDF", "EXCEL", "CSV"],
    };
  },
  computed: {
    formattedStartDt() {
      if (!this.startDt) return ""; // Return empty if no date is selected

      // Create a JavaScript Date object from the selected date
      const date = new Date(this.startDt);

      // Define month names array
      const monthNames = [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ];

      // Get day, month, and year
      const day = date.getDate().toString().padStart(2, "0");
      const month = monthNames[date.getMonth()];
      const year = date.getFullYear();

      // Return formatted date as DD-MMM-YYYY
      return `${day}-${month}-${year}`;
    },
    formattedEndDt() {
      if (!this.endDt) return ""; // Return empty if no date is selected

      // Create a JavaScript Date object from the selected date
      const date = new Date(this.endDt);

      // Define month names array
      const monthNames = [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ];

      // Get day, month, and year
      const day = date.getDate().toString().padStart(2, "0");
      const month = monthNames[date.getMonth()];
      const year = date.getFullYear();

      // Return formatted date as DD-MMM-YYYY
      return `${day}-${month}-${year}`;
    },
    filteredResults() {
      return this.results.filter((item) => item.settlementDate !== "SUBTOTALS");
    },
  },
  watch: {
    pagination: {
      handler() {},
      deep: true,
    },
    startDt(newVal) {
      if (newVal) {
        this.getDataFromApi();
      }
    },
    endDt(newVal) {
      if (newVal) {
        this.getDataFromApi();
      }
    },
  },
  mounted() {
    this.loggedInUser = JSON.stringify(
      store.state.user.merchant.merchantId.replace(/['"]+/g, "")
    );
    console.log("Merchant Stores ===> " + JSON.stringify(store.state.user));
    console.log(
      "LoggedIn User===> " + this.loggedInUser.trim().replace(/"/g, "")
    );
    this.stores = store.state.user.posStores;
    const mapFunction = (p) => p.name;
    const mapIdFunction = (pid) => pid.storeId;
    this.storeNames = this.stores.map(mapFunction);
    if (this.stores.length > 1) {
      this.storeNames.unshift("ALL");
    }
    this.selectedStore = this.storeNames[0]; // Set to "ALL" by default
    this.storeIds = this.stores.map(mapIdFunction);
    this.merchantId = this.stores.length > 1 ? "ALL" : this.storeIds[0]; // Set merchantId to "ALL" or the first store's ID

    this.getDataFromApi();
  },
  methods: {
    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        let items = this.getTransactions();
        const total = items.length;

        if (this.pagination.sortBy) {
          items = items.sort((a, b) => {
            const sortA = a[sortBy];
            const sortB = b[sortBy];

            if (descending) {
              if (sortA < sortB) return 1;
              if (sortA > sortB) return -1;
              return 0;
            } else {
              if (sortA < sortB) return -1;
              if (sortA > sortB) return 1;
              return 0;
            }
          });
        }

        if (rowsPerPage > 0) {
          items = items.slice((page - 1) * rowsPerPage, page * rowsPerPage);
        }

        setTimeout(() => {
          this.loading = false;
          resolve({
            items,
            total,
          });
        }, 1000);
      });
    },
    handleStoreChange() {
      if (this.selectedStore === "ALL") {
        this.merchantId = "ALL"; // Handle case for "ALL" selected
      } else {
        const selectedIndex = this.storeNames.indexOf(this.selectedStore);
        this.merchantId = this.storeIds[selectedIndex - 1]; // Get correct store ID based on selection
      }
      this.getDataFromApi(); // Re-fetch data after store change
    },
    // getTransactions() {
    //   this.results = [];
    //   this.totalResults = 0;
    //   var storeNameFilter = "storeName=" + this.merchantId;
    //   var url =
    //     config.serverURI + "/transactions/statement/get/pos?" + storeNameFilter;
    //   console.log(url);
    //   var token = store.state.token;
    //   axios
    //     .get(url, {
    //       headers: {
    //         Authorization: token,
    //         "Content-Type": "application/json",
    //       },
    //     })
    //     .then((response) => {
    //       if (response.status !== 200) {
    //         this.error = response.statusText;
    //         return;
    //       }
    //       this.results = response.data;
    //       this.totalResults = this.results.total;
    //     })
    //     .catch((error) => {
    //       var data = error.response.data;
    //       if (
    //         data.message === "Unauthorized" ||
    //         error.response.status === 401
    //       ) {
    //         console.log("redirecting");
    //         window.location = "/login";
    //       } else {
    //         this.error = data.message;
    //       }
    //     });
    //   return this.results;
    // },
    getTransactions() {
      // reset transaction object and count
      this.results = [];
      if (this.startDt == null) {
        const today = new Date();
        today.setDate(today.getDate() - 1);
        this.startDt = today.toISOString().split("T")[0];
      }
      if (this.endDt == null) {
        const today = new Date();
        this.endDt = today.toISOString().split("T")[0];
      }
      this.totalResults = 0;
      var storeNameFilter = "storeName=" + this.merchantId;
      // this.exportExcelFile();
      var dateFilter =
        "&startDate=" +
        this.startDt +
        "&endDate=" +
        this.endDt +
        "&loggedInUser=" +
        this.loggedInUser.trim().replace(/"/g, "");
      var url =
        config.serverURI +
        "/transactions/statement/get/postoday?" +
        storeNameFilter +
        dateFilter;
      console.log(url);
      var token = store.state.token;
      axios
        .get(url, {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          if (response.status !== 200) {
            this.error = response.statusText;
            return;
          }
          this.results = response.data;
          this.totalResults = this.results.total;
        })
        .catch((error) => {
          var data = error.response.data;
          if (
            data.message === "Unauthorized" ||
            error.response.status === 401
          ) {
            console.log("redirecting");
            window.location = "/login";
          } else {
            this.error = data.message;
          }
        });
      return this.results;
    },
    exportExcelFile() {
      // this.loadMethod();
      this.exportExcel();
    },
    async getStmtData() {
      // reset transaction object and count
      this.results = [];
      this.totalResults = 0;
      var storeNameFilter = "storeName=" + this.merchantId;
      var dateFilter =
        "&startDate=" +
        this.startDt +
        "&endDate=" +
        this.endDt +
        "&loggedInUser=" +
        this.loggedInUser.trim().replace(/"/g, "");
      var url =
        config.serverURI +
        "/transactions/statement/get/posmpcs?" +
        storeNameFilter +
        dateFilter;
      console.log(url);
      var token = store.state.token;
      axios
        .get(url, {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          if (response.status !== 200) {
            this.error = response.statusText;
            return;
          }
          this.results = response.data;
          this.totalResults = this.results.total;
        })
        .catch((error) => {
          var data = error.response.data;
          if (
            data.message === "Unauthorized" ||
            error.response.status === 401
          ) {
            console.log("redirecting");
            window.location = "/login";
          } else {
            this.error = data.message;
          }
        });
      return this.results;
    },
    async exportExcel() {
      const stm = {
        merchantId: this.merchantId,
        startDt: this.startDt,
        endDt: this.endDt,
        loggedInUser: this.loggedInUser.trim().replace(/"/g, ""),
      };
      var token = store.state.token;
      var url = config.serverURI + "/transactions/export/postoday";
      try {
        const response = await axios.post(url, stm, {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        });
        console.log(response.data.base64);
        if (response.data.status === "00") {
          const base64Data = response.data.base64;
          const binaryData = atob(base64Data);
          const arrayBuffer = new ArrayBuffer(binaryData.length);
          const uint8Array = new Uint8Array(arrayBuffer);
          for (let i = 0; i < binaryData.length; i++) {
            uint8Array[i] = binaryData.charCodeAt(i);
          }
          const blob = new Blob([uint8Array], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const MIN_SIZE = 28672;
          console.log(`Blob size: ${blob.size} bytes`);
          if (blob.size > MIN_SIZE) {
            const downloadLink = document.createElement("a");
            downloadLink.href = URL.createObjectURL(blob);
            downloadLink.download =
              "Merchant_portal_" + this.merchantId + "_" + new Date().getTime() + ".xls";
            downloadLink.click();
            this.loadingSpin = false;
          }
        } else {
        }
      } catch (error) {
        if (error.response.status === 401) {
          // Handle 401 error (Unauthorized)
          console.error("Unauthorized: Please log in.");
        } else {
          // Handle other errors
          console.error("Error:", error.message);
        }
      }
    },
    loadMethod() {
      this.loadingSpin = true;
    },
    async exportExcelOld() {
      const stm = {
        accountNo: this.accountNo,
        fileType: this.fileType,
        startDt: this.startDt,
        endDt: this.endDt,
        curUser: "lvbarasa@gmail.com",
        request: "account",
      };
      var token = store.state.token;
      var url = config.serverURI + "/accountStatement";
      try {
        const response = await axios.post(url, stm, {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        });
        console.log(response.data.base64);
        const base64Data = response.data.base64;
        const binaryData = atob(base64Data);
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }
        const blob = new Blob([uint8Array], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.download = "Account_statemet_" + new Date() + ".xlsx";
        downloadLink.click();
      } catch (error) {
        if (error.response.status === 401) {
          // Handle 401 error (Unauthorized)
          console.error("Unauthorized: Please log in.");
        } else {
          // Handle other errors
          console.error("Error:", error.message);
        }
      }
    },
    async getACCSTmt() {
      const stm = {
        accountNo: this.accountNo,
        fileType: this.fileType,
        startDt: this.startDt,
        endDt: this.endDt,
        curUser: "lvbarasa@gmail.com",
        request: "account",
      };
      var token = store.state.token;
      var url = config.serverURI + "/accountStatement";
      try {
        const response = await axios.post(url, stm, {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        });
        this.pdfData = "data:application/pdf;base64," + response.data.base64;
        this.loadstmt = true;
        console.log(response.data.base64);
        // Handle successful response
      } catch (error) {
        if (error.response.status === 401) {
          // Handle 401 error (Unauthorized)
          console.error("Unauthorized: Please log in.");
        } else {
          // Handle other errors
          console.error("Error:", error.message);
        }
      }
    },
    getAccountNumbers(storeId) {
      // this.results = []
      // this.totalResults = 0
      // var storeNameFilter = 'storeName=' + this.selectedStore
      // var dateFilter = '&startDate=' + this.startDate + '&endDate=' + this.endDate
      // var url = config.serverURI + '/transactions/get/pos?' + storeNameFilter + dateFilter
      // console.log(url)
      // var token = store.state.token
      this.results = [];
      var storeIdFilter = "storeId=" + storeId;
      var url = config.serverURI + "/merchant/accountnumber?" + storeIdFilter;
      console.log(url);
      var token = store.state.token;
      axios
        .get(url, {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          if (response.status !== 200) {
            this.error = response.statusText;
            return;
          }
          this.results = response.data;
        })
        .catch((error) => {
          var data = error.response.data;
          if (
            data.message === "Unauthorized" ||
            error.response.status === 401
          ) {
            console.log("redirecting");
            window.location = "/login";
          } else {
            this.error = data.message;
          }
        });
    },
    getStoreId() {
      this.stores = store.state.user.posStores;
      if (this.stores.length > 0) {
        const mapFunctionId = (p) => p.storeId;
        this.merchantid = this.stores.map(mapFunctionId)[0];
        if (this.stores.length > 1) {
          this.storeNames.unshift("ALL");
        }
      }
      return this.merchantid;
    },
  },
};
</script>
<style>
.info-box {
  cursor: pointer;
}

.info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
}

.fullCanvas {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// viewposstatementstoday.vue?87567cde